// prizes.js (service)
import axios from 'axios';

/**
 * Retrieve prizes data from API
 * @param {string} userLanguage - Language parameter for API call
 * @returns {Promise} API response with prizes data
 */
export const retrievePrizes = async (userLanguage = 'EN') => {
  const response = await axios({
    url: `api/getPrizeData?lang=${ userLanguage }`,
    method: 'GET',
  });

  return {
    data: response.data.data,
  };
};
